// 品牌
export const getBrandsMap = (t: any, locale: string) => {
    const brandsMap: any = {
        us: {
            country: 'United States',
            brands: [
                { img: ['/media/wheretobuy/offcial/pc/1.webp', '/media/wheretobuy/offcial/pc/1.png'], link: 'https://us.ecoflow.com/' },
                {
                    img: ['/media/wheretobuy/offcial/pc/2.webp', '/media/wheretobuy/offcial/pc/2.png'],
                    link: 'https://www.amazon.com/stores/EFECOFLOW/page/4BFF29AC-A220-4ABD-AFDC-9D612039F6A1?ref_=ast_bln',
                },
                { img: ['/media/wheretobuy/offcial/pc/3.webp', '/media/wheretobuy/offcial/pc/3.png'], link: 'https://www.rei.com/search?q=ECOFLOW' },
                {
                    img: ['/media/wheretobuy/offcial/pc/4.webp', '/media/wheretobuy/offcial/pc/4.png'],
                    link: 'https://www.homedepot.com/b/Outdoors-Outdoor-Power-Equipment-Generators-Portable-Power-Stations-Battery-Generators/EcoFlow/N-5yc1vZ2fkoqhoZndu/Ntk-elasticplus/Ntt-ecoflow?Ntx=mode+matchpartialmax&NCNI-5&visNavSearch=ecoflow',
                },
                { img: ['/media/wheretobuy/offcial/pc/5.webp', '/media/wheretobuy/offcial/pc/5.png'], link: 'https://www.costco.com/ecoflow-schedule.html' },
                { img: ['/media/wheretobuy/offcial/pc/6.webp', '/media/wheretobuy/offcial/pc/6.png'] },
                { img: ['/media/wheretobuy/offcial/pc/7.webp', '/media/wheretobuy/offcial/pc/7.png'], link: 'https://www.lowes.com/search?searchTerm=ecoflow' },
                { img: ['/media/wheretobuy/offcial/pc/8.webp', '/media/wheretobuy/offcial/pc/8.png'], link: 'https://www.tractorsupply.com/tsc/brand/EcoFlow' },
                { img: ['/media/wheretobuy/offcial/pc/9.webp', '/media/wheretobuy/offcial/pc/9.png'], link: 'https://www.target.com/s?searchTerm=EcoFlow' },
                {
                    img: ['/media/wheretobuy/offcial/pc/10.webp', '/media/wheretobuy/offcial/pc/10.png'],
                    link: 'https://www.bestbuy.com/site/searchpage.jsp?st=ecoflow&_dyncharset=UTF-8&_dynSessConf=&id=pcat17071&type=page&sc=Global&cp=1&nrp=&sp=&qp=&list=n&af=true&iht=y&usc=All+Categories&ks=960&keys=keys',
                },
                { img: ['/media/wheretobuy/offcial/pc/11.webp', '/media/wheretobuy/offcial/pc/11.png'], link: 'https://www.ebay.com/str/ecoflowofficial' },
                { img: ['/media/wheretobuy/offcial/pc/12.webp', '/media/wheretobuy/offcial/pc/12.png'], link: 'https://www.walmart.com/search?q=EF+EcoFlow' },
                {
                    img: ['/media/wheretobuy/offcial/pc/13.webp', '/media/wheretobuy/offcial/pc/13.png'],
                    // link: 'https://www.northerntool.com/shop/tools/NTESearch?storeId=6970&ipp=48&Ntt=ecoflow',
                    link: 'https://www.northerntool.com/brands/ecoflow',
                },
                {
                    img: ['/media/wheretobuy/offcial/pc/20.webp', '/media/wheretobuy/offcial/pc/20.png'],
                },
                {
                    img: ['/media/wheretobuy/offcial/pc/21.webp', '/media/wheretobuy/offcial/pc/21.png'],
                    link: 'https://www.harborfreight.com/search?q=EcoFlow',
                },
                {
                    img: ['/media/wheretobuy/offcial/pc/22.webp', '/media/wheretobuy/offcial/pc/22.jpg'],
                    link: 'https://shopsolarkits.com/#/c2529e94-5ed2-4057-b71d-9332d34d96ca/embedded/autofilters=true&page=1&query=ECOFLOW&query_name=match_none&rpp=50',
                },
                {
                    img: ['/media/wheretobuy/offcial/pc/23.webp', '/media/wheretobuy/offcial/pc/23.jpg'],
                    link: 'https://www.wellbots.com/search?type=product&options%5Bprefix%5D=last&options%5Bunavailable_products%5D=last&q=ecoflow',
                },
                {
                    img: ['https://websiteoss.ecoflow.com/upload/image/1749526654320/campervanhq.png'],
                    link: 'https://www.campervan-hq.com/',
                },
            ],
        },
        'us-vi': {
            country: 'U.S. Virgin Islands',
            brands: [
                {
                    img: ['/media/wheretobuy/offcial/pc/25.png', '/media/wheretobuy/offcial/pc/25.png'],
                    link: 'https://backitups.com/ols/categories/ecoflow',
                    isArea: true,
                },
            ],
        },

        ca: {
            country: 'Canada',
            brands: [
                {
                    img: ['/media/wheretobuy/offcial/pc/1.webp', '/media/wheretobuy/offcial/pc/1.png'],
                    link: 'https://ca.ecoflow.com/',
                },
                {
                    img: ['/media/wheretobuy/offcial/pc/14.webp', '/media/wheretobuy/offcial/pc/14.png'],
                    link: 'https://www.amazon.ca/stores/EFECOFLOW/page/20C3DB9D-74BA-4AE9-93C4-D888FC16B7F4?ref_=ast_bln',
                },
                {
                    img: ['/media/wheretobuy/offcial/pc/10.webp', '/media/wheretobuy/offcial/pc/10.png'],
                    link: 'https://www.bestbuy.ca/en-ca/search?search=EcoFlow',
                },
                {
                    img: ['/media/wheretobuy/offcial/pc/5.webp', '/media/wheretobuy/offcial/pc/5.png'],
                    link: 'https://www.costco.ca/s?langId=-24&keyword=EcoFlow',
                },
                // {
                //     img: ['/media/wheretobuy/offcial/pc/15.webp', '/media/wheretobuy/offcial/pc/15.png'],
                //     link: 'https://modularacks.com/pages/search-results-page?q=ecoflow',
                // },
                // {
                //     img: ['/media/wheretobuy/offcial/pc/21.webp', '/media/wheretobuy/offcial/pc/21.png'],
                //     link: 'https://www.harborfreight.com/search?q=EcoFlow',
                // },
                {
                    img: [
                        'https://websiteoss.ecoflow.com/upload/image/1754028410408/shop%20solar.png',
                        'https://websiteoss.ecoflow.com/upload/image/1754028410408/shop%20solar.png',
                    ],
                    link: 'https://shopsolarkits.com/collections/ecoflow',
                },
                // {
                //     img: ['/media/wheretobuy/offcial/pc/23.webp', '/media/wheretobuy/offcial/pc/23.jpg'],
                //     link: 'https://www.wellbots.com/search?type=product&options%5Bprefix%5D=last&options%5Bunavailable_products%5D=last&q=ecoflow',
                // },
                {
                    img: ['/media/wheretobuy/offcial/pc/24.webp', '/media/wheretobuy/offcial/pc/24.png'],
                    link: 'https://www.tsc.ca/pages/productresults?dimensions=3004108&rd=1&searchterm=ecoflow',
                },
                {
                    img: [
                        'https://websiteoss.ecoflow.com/upload/image/1721180874609/20240716-161107.jpg',
                        'https://websiteoss.ecoflow.com/upload/image/1721180874609/20240716-161107.jpg',
                    ],
                    link: 'https://www.batteriesexpert.com/product_search/?q=EcoFlow',
                },
                {
                    img: [
                        'https://websiteoss.ecoflow.com/upload/image/1754028410090/Canadian_Tire_logo_2022.png',
                        'https://websiteoss.ecoflow.com/upload/image/1754028410090/Canadian_Tire_logo_2022.png',
                    ],
                    link: 'https://www.canadiantire.ca/en/search-results.html?q=EcoFlow',
                },
                {
                    img: [
                        'https://websiteoss.ecoflow.com/upload/image/1754028410625/londondrugs.png',
                        'https://websiteoss.ecoflow.com/upload/image/1754028410625/londondrugs.png',
                    ],
                    link: 'https://www.londondrugs.com/search?q=EcoFlow&autoFiltersApplied=true',
                },
                {
                    img: [
                        'https://websiteoss.ecoflow.com/upload//1754028410164/craze%20outdoor%20logo.avif',
                        'https://websiteoss.ecoflow.com/upload//1754028410164/craze%20outdoor%20logo.avif',
                    ],
                    link: 'https://crazeoutdoors.com/collections/ecoflow?srsltid=AfmBOop8rGGys8_qvsEi0USH12qBCyqzyx5AUZ8N7ZHvJu4cWrSexdhD',
                },
                {
                    img: [
                        'https://websiteoss.ecoflow.com/upload/image/1760065838731/1667945785696%20(1).jpeg',
                        'https://websiteoss.ecoflow.com/upload/image/1760065838731/1667945785696%20(1).jpeg',
                    ],
                    link: 'https://truoffgrid.com/shop',
                },
            ],
        },
        cn: {
            country: '中国',
            brands: [
                {
                    img: ['/media/wheretobuy/offcial/pc/16.webp', '/media/wheretobuy/offcial/pc/16.png'],
                    link: 'https://u.jd.com/xMUCTB1',
                },
                {
                    img: ['/media/wheretobuy/offcial/pc/19.webp', '/media/wheretobuy/offcial/pc/19.png'],
                    link: 'https://u.jd.com/xMUL3UY',
                },
                {
                    img: ['/media/wheretobuy/offcial/pc/17.webp', '/media/wheretobuy/offcial/pc/17.png'],
                    link: 'https://ecoflow.tmall.com/?spm=a220o.1000855.1997427721.d4918089.37a29352j6oQdE',
                },
                {
                    img: ['/media/wheretobuy/offcial/pc/18.webp', '/media/wheretobuy/offcial/pc/18.png'],
                    bigImg: {
                        img: ['/media/wheretobuy/offcial/pc/18_hover.webp', '/media/wheretobuy/offcial/pc/18_hover.png'],
                        title: t('douyin_title'),
                        desc: t('douyin_desc'),
                    },
                },
            ],
        },
        'cn-hk': {
            country: 'China',
            brands: [
                {
                    img: ['https://websiteoss.ecoflow.com/upload/image/1762497356232/1.jpeg'],
                    link: 'https://www.futex.hk/',
                },
            ],
        },
    };
    return {
        brandListsCur: brandsMap[locale] || brandsMap.us,
        brandsMap,
    };
};

export const getOutlyingIslandsStores = (locale: string) => {
    const localesMap: any = {
        us: [
            {
                state: 'Hawaii',
                img: '1.jpg',
                storeName: 'Battery Bill',
                address: '550 North Nimitz Hwy #1A Honolulu, Hawaii 96817',
                time: 'Mon-Fri: 8am – 4:30pm\nSat: 8am – 4pm\nSun: Closed',
                tel: '(808) 536-4017',
                link: 'https://batterybill.com/',
            },
            {
                state: 'Hawaii',
                img: '1.jpg',
                storeName: 'Battery Bill',
                address: '960 Ahua Street Honolulu, Hawaii 96819',
                time: 'Mon-Fri: 8am – 4:30pm\nSat: 8am – 4pm\nSun: Closed',
                tel: '808-833-3797',
                link: 'https://batterybill.com/',
            },
            {
                state: 'Hawaii',
                img: '1.jpg',
                storeName: 'Battery Bill',
                address: '76 Keaa Street Hilo, Hawaii 96720',
                time: 'Mon-Fri: 8am – 4:30pm\nSat: Closed\nSun: Closed',
                tel: '(808) 498-0698',
                link: 'https://batterybill.com/',
            },
            {
                state: 'Puerto Rico',
                img: '2.jpg',
                storeName: 'Power Solar PR',
                address: 'Local #121 B 150 Carr 940 Fajardo, PR, 00738',
                time: '09:00 AM-06:00 PM',
                tel: '787-331-1000',
                link: 'https://powersolarpr.com/',
            },
            {
                state: 'Puerto Rico',
                img: '2.jpg',
                storeName: 'Power Solar PR',
                address: '525 Av. Franklin Delano Roosevelt San Juan, PR, 00918',
                time: '09:00 AM-06:00 PM',
                tel: '787-331-1000',
                link: 'https://powersolarpr.com/',
            },
            {
                state: 'Puerto Rico',
                img: '2.jpg',
                storeName: 'Power Solar PR',
                address: '506 Truncado Street Ste. 2 Hatillo, PR, 00659',
                time: '09:00 AM-06:00 PM',
                tel: '787-331-1000',
                link: 'https://powersolarpr.com/',
            },
            {
                state: 'Puerto Rico',
                img: '2.jpg',
                storeName: 'Power Solar PR',
                address: '725 W Main Ave Bayamon, PR, 00961',
                time: '09:00 AM-06:00 PM',
                tel: '787-331-1000',
                link: 'https://powersolarpr.com/',
            },
            {
                state: 'Puerto Rico',
                img: '2.jpg',
                storeName: 'Power Solar PR',
                address: 'Plaza Hostos, 2599, 6413 Av. Eugenio María de Hostos Mayaguez, PR, 00682',
                time: '09:00 AM-06:00 PM',
                tel: '787-331-1000',
                link: 'https://powersolarpr.com/',
            },
            {
                state: 'Puerto Rico',
                img: '2.jpg',
                storeName: 'Power Solar PR',
                address: '206 San Jacinto Street San Juan, PR, 00921',
                time: '09:00 AM-06:00 PM',
                tel: '787-331-1000',
                link: 'https://powersolarpr.com/',
            },
            {
                state: 'Puerto Rico',
                img: '2.jpg',
                storeName: 'Power Solar PR',
                address: 'PR 2, PR-4494, Isabela, 00662 Isabela, PR, 00662',
                time: '09:00 AM-06:00 PM',
                tel: '787-600-2712',
                link: 'https://powersolarpr.com/',
            },
            {
                state: 'Puerto Rico',
                img: '2.jpg',
                storeName: 'Power Solar PR',
                address: '2933 Emilio Fagot Avenue Ponce, PR, 00717',
                time: '09:00 AM-06:00 PM',
                tel: '787-331-1000',
                link: 'https://powersolarpr.com/',
            },
            {
                state: 'Puerto Rico',
                img: '2.jpg',
                storeName: 'Power Solar PR',
                address: 'Rio Hondo Blvd Ste 8080 Bavamon, PR, 00936',
                time: '09:00 AM-06:00 PM',
                tel: '787-923-9624',
                link: 'https://powersolarpr.com/',
            },
            {
                state: 'Puerto Rico',
                img: '2.jpg',
                storeName: 'Power Solar PR',
                address: '1000 The Mall of San Juan Blvd San Juan, PR, 00924',
                time: '09:00 AM-06:00 PM',
                tel: '787-331-1000',
                link: 'https://powersolarpr.com/',
            },
            {
                state: 'Puerto Rico',
                img: '2.jpg',
                storeName: 'Power Solar PR',
                address: '1995 Veterans Avenue, 102 Guayama, PR, 00784',
                time: '09:00 AM-06:00 PM',
                tel: '787-930-5642',
                link: 'https://powersolarpr.com/',
            },
            {
                state: 'USVI',
                img: '3.jpg',
                storeName: 'BACK IT UPS',
                address: 'https://backitups.com/',
                tel: '(336) 695 0371',
                link: 'https://backitups.com/',
            },
            {
                state: 'Guam',
                img: '4.jpg',
                storeName: 'Guam Choice Wholesale',
                address: 'https://ecoflowguam.com/',
                tel: '(671) 864-9796',
                link: 'https://ecoflowguam.com/',
            },
            {
                state: 'Hong Kong, Macao',
                img: '5.jpg',
                storeName: 'FUTEX Corporation Limited',
                address: 'Unit-C, 2/F., West Gate Tower, No. 7 Wing Hong Street, Lai Chi Kok, Kowloon, Hong Kong.',
                time: 'Mon-Fri 09:30-18:30\nSat & Sun & Public Holiday: Closed',
                tel: '+852 3871 8888',
                link: 'https://www.futex.hk/',
            },
        ],
    };
    return localesMap[locale] || localesMap.us;
};
